<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex sm12>
        <div class="headline green--text text--darken-4 font-weight-medium">
          Send Dispatch Details via SMS
        </div>
      </v-flex>
      <v-flex sm12>
        <v-card style="width: 500px">
          <v-card-text>
            <v-text-field
              v-model.trim="dlgModel.Name"
              name="patientName"
              label="Recipient Name:"
              v-validate="{ required: true }"
              :error="!!errors.has('patientName')"
              :error-messages="errors.first('patientName')"
            ></v-text-field>
            <v-text-field
              v-model.trim="dlgModel.Mobile"
              name="mobile"
              label="Recipient Mobile:"
              v-validate="{ required: true }"
              :error="!!errors.has('mobile')"
              :error-messages="errors.first('mobile')"
            ></v-text-field>
            <v-text-field
              v-model.trim="dlgModel.TrackingId"
              name="trackingId"
              label="Tracking Id:"
              v-validate="{ required: true }"
              :error="!!errors.has('trackingId')"
              :error-messages="errors.first('trackingId')"
            ></v-text-field>
            <div v-show="submit.error">
              <v-list two-line>
                <v-list-tile>
                  <span class="red--text">{{ submit.message }}</span>
                </v-list-tile>
              </v-list>
            </div>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat :disabled="submit.working" @click="clear">
                Clear
              </v-btn>
              <v-btn
                color="blue darken-1"
                flat
                :loading="submit.working"
                @click="saveDlg"
                >Save
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WebH from "@/api/web";

export default {
  data() {
    return {
      dlgModel: {},
      submit: {
        error: false,
        working: false,
        message: ""
      }
    };
  },
  methods: {
    clear() {
      this.dlgModel = {
        Name: "",
        Mobile: "",
        TrackingId: ""
      };
      this.submit = {
        error: false,
        working: false,
        message: ""
      };
      this.$validator.errors.clear();
    },
    async saveDlg() {
      const res = await this.$validator.validateAll();
      if (!res) return;
      this.api_create(this.dlgModel);
    },
    async api_create(data) {
      this.submit.working = true;
      const res = await WebH.Post("/sms", data);
      this.submit.working = false;
      if (res.Success) {
        this.$notify({ type: "info", text: "Successfully sent message" });
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    }
  }
};
</script>

<style scoped></style>
